


























import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'attribute-filter'
})

export default class extends Vue {
  @Prop(String) readonly dataSource: string;
  @Prop(Object) readonly filter!: object;

  private splitColumns: boolean = this.filter['layout'] === '2columns';
  readonly filtersToShow: number = this.splitColumns ? 10 : 5;
  readonly smallBreakpoint: number = 768;
  private filterCollapsed: boolean = this.filter['options'].length > this.filtersToShow;
  private filterOpen: boolean = window.outerWidth >= this.smallBreakpoint;

  toggleFilterValueCollapse(): void {
    this.filterCollapsed = !this.filterCollapsed;
  }

  filterIsVisibleCheck(index): boolean {
    return this.filterCollapsed ? index < this.filtersToShow : true;
  }

  toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }

  private get sortedFilter(): object {
    return this.filter['options'].sort((a,b) => a['label'] > b['label'] ? 1 : -1);
  }
}
